import React from 'react';
import { Typography, Space, Tag, QRCode } from 'antd';
import { UserOutlined, ShopOutlined } from '@ant-design/icons';

const { Text } = Typography;

interface ComboLabelProps {
  data: {
    comboItem: {
      id: number;
      quantity: number;
      unitPrice: number;
      priceTotal: number;
    };
    combo: {
      title: string;
    };
    order: {
      id: number;
      customerCompany: string;
      supplierCompany: string;
      supplierPhone: string;
    };
    selectionsSnapshot: any;
    qrCode: string;
  };
}

const ComboLabel: React.FC<ComboLabelProps> = ({ data }) => {
  const groups = Array.isArray(data.selectionsSnapshot) ? data.selectionsSnapshot : [];

  return (
    <div
      style={{
        width: '60mm',
        minHeight: '90mm',
        padding: '6px',
        border: '2px solid #000',
        backgroundColor: '#fff',
        fontFamily: 'monospace',
        fontSize: '11px',
        lineHeight: '1.1'
      }}
    >
      <div style={{ textAlign: 'center', marginBottom: '6px' }}>
        <Text strong style={{ fontSize: '14px' }}>
          🧩 {data.combo.title || 'Комбо'}
        </Text>
        <br />
        <Text style={{ fontSize: '12px' }}>Заказ #{data.order.id}</Text>
      </div>

      <div style={{ textAlign: 'center', marginBottom: '6px' }}>
        <QRCode value={data.qrCode} size={80} style={{ border: '1px solid #000' }} />
      </div>

      <div style={{ marginBottom: '6px', textAlign: 'center' }}>
        <Text style={{ fontSize: '10px' }}>
          <ShopOutlined /> {data.order.customerCompany}
        </Text>
        <br />
        <Text style={{ fontSize: '10px' }}>
          <UserOutlined /> Комбо-позиция #{data.comboItem.id}
        </Text>
      </div>

      <div style={{ marginBottom: '6px', textAlign: 'center' }}>
        <Text strong style={{ fontSize: '12px' }}>
          Количество: {data.comboItem.quantity} шт
        </Text>
        <br />
        <Text style={{ fontSize: '11px' }}>
          Цена: {data.comboItem.unitPrice}₽
        </Text>
      </div>

      {groups.length > 0 && (
        <div style={{ marginBottom: '6px' }}>
          <Text strong style={{ fontSize: '11px' }}>
            Состав:
          </Text>
          {groups.map((g: any) => (
            <div key={g.groupId || g.title} style={{ marginTop: 2 }}>
              <Text style={{ fontSize: '10px' }}>
                {g.title}: {(g.items || []).map((it: any) => it.name).join(', ') || '—'}
              </Text>
            </div>
          ))}
        </div>
      )}

      <div style={{ textAlign: 'center', borderTop: '1px solid #ccc', paddingTop: '4px' }}>
        <Space size={4} wrap style={{ justifyContent: 'center' }}>
          <Tag>Комбо</Tag>
        </Space>
        <div>
          <Text style={{ fontSize: '9px' }}>🏪 {data.order.supplierCompany}</Text>
        </div>
        <div>
          <Text style={{ fontSize: '9px' }}>📞 {data.order.supplierPhone}</Text>
        </div>
      </div>
    </div>
  );
};

export default ComboLabel;

